<template>
  <g>
    <path
      d="M12 6.00024C13.1046 6.00024 14 5.10481 14 4.00024C14 2.89567 13.1046 2.00024 12 2.00024C10.8954 2.00024 10 2.89567 10 4.00024C10 5.10481 10.8954 6.00024 12 6.00024Z"
    />
    <path
      d="M15.89 8.11024C15.5 7.72024 14.83 7.00024 13.53 7.00024C13.32 7.00024 12.11 7.00024 10.99 7.00024C8.52999 6.99024 6.47999 5.20024 6.06999 2.85024C5.98999 2.36024 5.57999 2.00024 5.08999 2.00024C4.47999 2.00024 3.99999 2.54024 4.08999 3.14024C4.52999 5.80024 6.46999 7.95024 8.99999 8.71024V21.0002C8.99999 21.5502 9.44999 22.0002 9.99999 22.0002C10.55 22.0002 11 21.5502 11 21.0002V16.0002H13V21.0002C13 21.5502 13.45 22.0002 14 22.0002C14.55 22.0002 15 21.5502 15 21.0002V10.0502L18.24 13.2902C18.63 13.6802 19.26 13.6802 19.65 13.2902C20.04 12.9002 20.04 12.2702 19.65 11.8802L15.89 8.11024Z"
    />
  </g>
</template>
